import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Container,
  IconButton,
  Typography,
} from "@mui/material";

import {
  ArrowBackIosNew,
  ArrowForwardIos,
} from "@mui/icons-material";

import { useNoticiasPublicas} from "../../hooks/useNoticias";

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import imagen from "../../assets/img/banner.jpeg";


const generarSlug = (titulo) => {

  return titulo
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
};

export const NoticiasHome = () => {

 const {
        noticias,
        loading,
        error,
    } = useNoticiasPublicas();

const sliderRef = useRef(null);

const [progress,setProgress] = useState(0);
const sectionRef = useRef(null);
const [visible,setVisible] = useState(false);

const navigate = useNavigate();

const backendURL = process.env.REACT_APP_BACKEND_URL;

  const handleLeerNoticia = (noticia) => {

  const tituloSlug = generarSlug(noticia.titulo);

  navigate(`/noticias/${tituloSlug}`);

};


  
useEffect(()=>{

const observer = new IntersectionObserver(
([entry])=>{

if(entry.isIntersecting){

setVisible(true);

}else{

setVisible(false);

}

},
{
threshold:0.2
}

);


if(sectionRef.current){
observer.observe(sectionRef.current);
}


return ()=>observer.disconnect();


},[]);

const mover = (direccion) => {
  const slider = sliderRef.current;

  if (!slider) return;

  const card = slider.querySelector(".card-noticia");

  if (!card) return;

  slider.scrollBy({
    left: direccion * (card.offsetWidth + 32),
    behavior: "smooth",
  });
};



const actualizarLinea = () => {
  const slider = sliderRef.current;

  if (!slider) return;

  const maxScroll = slider.scrollWidth - slider.clientWidth;

  const porcentaje =
    maxScroll > 0
      ? (slider.scrollLeft / maxScroll) * 100
      : 0;

  setProgress(porcentaje);
};



return (

<Box
ref={sectionRef}
sx={{
  mt:10,
  position:"relative",
  width:'100%',
  py:{
  xs:8,
  md:12
  },
  background:"#f8f8f8",
  overflow:"hidden",

  opacity:visible?1:0,

  transform:visible
  ?"translateY(0)"
  :"translateY(60px)",

  transition:"1s ease"
}}
>

<Container maxWidth="lg">


{/* TITULO */}

<Box
sx={{
display:"flex",
alignItems:"center",
flexDirection:"column"
}}
>


<Typography
sx={{
color:"#484a75",
fontWeight:800,
lineHeight:1,
fontSize:{
xs:"1.8rem",
md:"2.5rem"
},
opacity:visible?1:0,

transform:visible
?"translateY(0)"
:"translateY(30px)",

transition:"0.8s ease",
}}
>
NOTICIAS
</Typography>


<Typography
sx={{
color:"#484a75",
fontWeight:800,
lineHeight:1,

opacity:visible?1:0,

transform:visible
?"translateY(0)"
:"translateY(30px)",

transition:"0.2s ease",

fontSize:{
xs:"1.8rem",
md:"2.5rem"
}
}}
>
COMUNIDAD
</Typography>



{/* LINEA CARRUSEL */}

<Box
sx={{
width:"100%",
height:4,
background:"#d8d8d8",
position:"relative",
mb:7,
overflow:"hidden"
}}
>


<Box
  sx={{
    position:"absolute",
    top:0,
    left: `${Math.min(progress, 65)}%`,

    height:"100%",
    width:{
      xs:"25%",
      sm:"30%",
      md:"35%"
    },

    background:"#222",
 transform:visible
    ?"translateX(-50%) scaleX(1)"
    :"translateX(-50%) scaleX(0)",


    transition:".25s",
  }}
/>


</Box>


</Box>





{/* CONTENEDOR SLIDER */}


<Box
sx={{
position:"relative",
py:3
}}
>



{/* FLECHA IZQUIERDA */}

<IconButton
onClick={()=>mover(-1)}
sx={{
display:{
    xs:"none",
    lg:"flex"
},
position:"absolute",
left:{
    lg:-30,
    xl:-50
},
top:"45%",
zIndex:5,
background:"#ddd",
width:50,
height:50,


"&:hover":{
background:"#ccc"
}

}}
>

<ArrowBackIosNew/>

</IconButton>






<Box
ref={sliderRef}
onScroll={actualizarLinea}

sx={{

display:"flex",

gap:{
    xs:2,
    sm:3,
    md:4
},
px: {
    xs: "7.5%",
    sm: 2,
    md: 1,
},

py: 2,

    overflowX: "auto",
    overflowY: "visible",

scrollBehavior:"smooth",

scrollSnapType:"x mandatory",

   scrollPaddingLeft: {
  xs: "16px",
  md: "24px",
},

scrollPaddingRight: {
  xs: "16px",
  md: "24px",
},
    touchAction: "pan-x",
    WebkitOverflowScrolling: "touch",
"&::-webkit-scrollbar":{
display:"none"
},
scrollbarWidth:"none",

msOverflowStyle:"none",


}}

>



{
noticias.map((item,index)=>(


<Box

key={index}

sx={{

flex: {
    xs: "0 0 110%",
    sm: "0 0 80%",
    md: "0 0 calc(50% - 20px)",
    lg: "0 0 calc(33.333% - 24px)",
},
scrollSnapAlign: {
  xs: "center",
  md: "start",
},
scrollSnapStop:"always",

}}

>



<Card
  className="card-noticia"
sx={{

height:"100%",

borderRadius:"30px",

boxShadow:"0 15px 40px rgba(0,0,0,.12)",

overflow:"hidden",

transition:".3s",
display:"flex",
flexDirection:"column",

"&:hover":{
transform:"translateY(-10px)"
}


}}

>


<CardMedia

component="img"

src={`${backendURL}/${item.img1}`}

sx={{

height:{
    xs:180,
    sm:220,
    md:240,
    lg:260
},

objectFit:"cover"

}}


/>



<CardContent
sx={{
    display:"flex",
flexDirection:"column",
flexGrow:1,
p:{
    xs:2.5,
    sm:3,
    md:4
}
}}
>


<Typography

sx={{

color:"#484a75",

fontWeight:700,

fontSize:{
    sm:"0.95rem",
    md:"1rem",
    lg:"1.4rem"
},

lineHeight:1.1,

minHeight:{
md:70
}

}}

>

{item.titulo}

</Typography>



<Typography

sx={{

mt:2,

color:"#666",

lineHeight:1.7,

mb:4,

display:"-webkit-box",
WebkitLineClamp:4,
WebkitBoxOrient:"vertical",
overflow:"hidden",
fontSize:{
    xs:'0.75rem',
    sm:"0.85rem",
    md:"0.95rem",
    lg:"1rem"
},

}}

>

{item.descripcion}

</Typography>




<Button
 onClick={() => handleLeerNoticia(item)}
sx={{

p:0,

mt:"auto",
color:"#666",

fontWeight:600,

textTransform:"uppercase",

"&:hover":{
background:"transparent",
color:"#484a75"
}

}}

>

LEER MÁS

</Button>


</CardContent>



</Card>


</Box>


))
}




</Box>





{/* FLECHA DERECHA */}


<IconButton

onClick={()=>mover(1)}

sx={{

display:{
    xs:"none",
    lg:"flex"
},


position:"absolute",

right:{
    lg:-30,
    xl:-50
},

top:"45%",


zIndex:5,


background:"#222",

color:"#fff",

width:50,

height:50,


"&:hover":{
background:"#333"
}


}}

>


<ArrowForwardIos/>


</IconButton>




</Box>


</Container>


</Box>

)

}